"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function RequestAConsultationCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="request-a-consultation-cta" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8" ref={ref}>
      <div className={`max-w-3xl mx-auto text-center transition-all duration-150 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mb-6">
          Request a Consultation
        </h2>
        <p className="text-lg sm:text-xl text-foreground-dark/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          Partner with AJ Dynasty Smart Behavioral Solution for reliable, compliant administrative support tailored to ABA and behavioral health providers.
        </p>
        <Link to="/GetStartedPage">
          <Button size="lg" className="btn-primary text-base sm:text-lg px-8 py-4 shadow-medium">
            Get Started Today
          </Button>
        </Link>
      </div>
    </section>;
}